"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Form = _interopRequireDefault(require("./Form"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "form": "DefaultTheme__form___1QKcl",
  "validationErrors": "DefaultTheme__validationErrors___2vx9z",
  "visually-hidden": "DefaultTheme__visually-hidden___1-I5Y",
  "visuallyHidden": "DefaultTheme__visually-hidden___1-I5Y"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "form": "DarkTheme__form___XQb1y"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "form": "LumeTheme__form___1LQmT"
};
require("../FormComponent/themes/DefaultTheme.css");
var FormComponentDefaultTheme = {
  "formComponent": "DefaultTheme__formComponent___xsYe2",
  "label": "DefaultTheme__label___2bZN6",
  "optional": "DefaultTheme__optional___3kh5d",
  "component": "DefaultTheme__component___1MsdN",
  "children": "DefaultTheme__children___1UmE-",
  "validationErrors": "DefaultTheme__validationErrors___1WaSy"
};
require("../FormComponent/themes/LumeTheme.css");
var FormComponentLumeTheme = {
  "label": "LumeTheme__label___3comc"
};
DefaultTheme.FormComponent = FormComponentDefaultTheme;
LumeTheme.FormComponent = FormComponentLumeTheme;
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_Form["default"].displayName, themes.DefaultTheme)(_Form["default"]);
ThemedComponent.displayName = _Form["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map